import { render, staticRenderFns } from "./EditTag.vue?vue&type=template&id=66c96a1c&scoped=true&"
import script from "./EditTag.vue?vue&type=script&lang=js&"
export * from "./EditTag.vue?vue&type=script&lang=js&"
import style0 from "@/styles/common.scss?vue&type=style&index=0&id=66c96a1c&prod&lang=scss&scoped=true&"
import style1 from "./EditTag.vue?vue&type=style&index=1&id=66c96a1c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c96a1c",
  null
  
)

export default component.exports